import { combineReducers } from 'redux';
import AppReducer from './App';
import EntitiesReducer from './Entities';
import ToastReducer from './Toast';
import PopupReducer from '../../../common/reducers/PopupReducer';
import feedbacklistReducer from '../containers/FeedBackList/reducers/feedbacklistReducer'
import OverviewReducer from "../containers/Overview/reducers"
import fetchOnlineReviewDataReducer from "../containers/OnlineReview/reducers"
import filterReducer from '../containers/Filters/reducers/filterReducer';
import feedbackdetailsreducer from '../containers/FeedBackDetails/reducers/feedbackdetailsreducer'
import sortReducer from '../containers/FeedBackList/reducers/sortReducer';
import insightsReducer from '../containers/AiAnalytics/reducer/AiAnalyticsReducer';
import alertSummaryReducer from '../containers/Alerts/reducers/alertSummaryReducer';

export default combineReducers({
  app: AppReducer,
  entities: EntitiesReducer,
  toast: ToastReducer,
  popupReducer: PopupReducer,
  feedBackListReducer: feedbacklistReducer,
  feedbackdetailsreducer:feedbackdetailsreducer,
  filterReducer:filterReducer,
  insightsReducer:insightsReducer,
  sortReducer:sortReducer,
  alertSummaryReducer:alertSummaryReducer,
  ...OverviewReducer,
  ...fetchOnlineReviewDataReducer

});
